<template>
	<div>
		<div
			class="ui grid"
			style=" padding:1em !important;margin-top: -1rem !important;margin-right: -1rem !important;margin-bottom: -1rem !important;margin-left: -1rem !important;"
		>
			<BaseCardMateriaReticula
				v-for="item in registroFinal"
				:key="item.claveMateria"
				:clave="item.claveMateria"
				:nombre="item.nombreMateria"
				:prerequisito="item.prerrequisitos"
				:corequisito="item.correquisitos"
				:especialidad="item.especialidad"
				:ubicacion="parseInt(item.ubicacion)"
				:creditos="item.creditosMateria"
				:es-prerequisito="esPrerequisito(item.claveMateria)"
				:es-corequisito="esCorequisito(item.claveMateria)"
				@prerequisitos="onPrerequisitos"
				@corequisitos="onCorequisitos"
				@borraPrerequisito="onBorrarPrerequisito"
				@borraCorequisito="onBorrarCorequisito"
			></BaseCardMateriaReticula>
		</div>
	</div>
</template>
<script>
export default {
	inheritAttrs: false,
	props: {
		materias: {
			type: Array,
			default: () => []
		},

		esPrerequisitoGral: {
			type: Array,
			default: () => []
		},
		esCorequisitoGral: {
			type: Array,
			default: () => []
		}
	},
	data: function() {
		return {
			mostrar: false,
			prerequisitos: [],
			columnas: 8
		};
	},
	computed: {
		registroFinal: function() {
			var res = [];
			for (let i = 0; i < this.columnas; i++) {
				if (typeof this.materias[i] === 'undefined') {
					res[i] = {
						cveMateria: '',
						nombreMateria: '',
						prerequisitos: '',
						corequisitos: '',
						ubicacion: 0,
						creditos: 0
					};
				} else {
					res[i] = this.materias[i];
				}
			}

			return res;
		}
	},
	watch: {},
	methods: {
		onPrerequisitos($event) {
			this.$emit('prerequisitosGeneral', $event);
		},
		onBorrarPrerequisito($event) {
			this.$emit('borrarPrerequisitosGeneral', $event);
		},
		esPrerequisito(clave) {
			return this.esPrerequisitoGral.filter((x) => x === clave).length > 0;
		},
		onCorequisitos($event) {
			this.$emit('corequisitosGeneral', $event);
		},
		onBorrarCorequisito($event) {
			this.$emit('borrarCorequisitosGeneral', $event);
		},
		esCorequisito(clave) {
			return this.esCorequisitoGral.filter((x) => x === clave).length > 0;
		}
	}
};
</script>
}
<style lang="scss" module>
@import '@design';
</style>
